var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderStock',{attrs:{"header":"ตั้งค่าข้อมูลเกี่ยวกับคลัง","img_header":_vm.header_image,"link_back":"stock"}}),_c('MenuStockSetting'),_c('StockSourceList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }